/** @fileoverview update_query_group の共通定数 */

/** ツール名（単一参照点） */
export const UPDATE_QUERY_GROUP_NAME = "update_query_group" as const;

/** LLM へ提示する説明文 */
export const UPDATE_QUERY_GROUP_DESC =
  `Updates an existing Search Analytics Query Group by ID.

Use this when a user wants to rename a Query Group, change its description, logical operator, or patterns.

Input:
- 'id' (required): Query Group ID.
- Optional: 'name', 'description' (string or null to clear), 'op' (AND/OR), 'patterns' [{ type, pattern }].

Notes:
- Search Analytics only. Write operation; a confirmation step will run before execution.
- Returns: updated QueryGroup { id, name, description, op, patterns }.` as const;
